import React, { PureComponent } from 'react'
import { Paper, Typography } from '@material-ui/core'

const classes = {
    cardPadding: {
        padding: '14px',
    },
    cardMargin: {
        paddingTop: 10,
        paddingBottom: 0,
    }
}

class DataCard extends PureComponent {
    render() {
        const { title, value, content, lg, special } = this.props;

        return (
            <div style={classes.cardMargin}>
                <Paper elevation={0}>
                    {title && (
                        <div style={{ ...classes.cardPadding, borderBottom: '1px solid #e0dfdf' }}>
                            <Typography variant="subtitle2">
                                {title}
                            </Typography>
                        </div>
                    )}
                    {value && (
                        <div style={special ? { ...classes.cardPadding, height: 115, display: 'flex', alignItems: 'center' } : classes.cardPadding}>
                            <Typography variant={lg ? 'h4' : 'body2'} align={lg ? 'center' : 'left'}>
                                {value}
                            </Typography>
                        </div>
                    )}
                    {content && (
                        <div style={classes.cardPadding}>
                            {content}
                        </div>
                    )}
                </Paper>
            </div>
        )
    }
}

export default DataCard;
